import {Image} from '@yandex-delivery/blocks/image'
import React, {memo} from 'react'

import {tagToUrl} from '../../lib/tagToUrl'
import type {IconSpotWidgetProps as Props} from '../types'
import * as classes from './IconSpot.classes'

export const IconSpotWidget = memo(({config: {icon_spot}}: Props): React.ReactElement => {
  return (
    <div
      className={classes.iconSpotWrapper}
      style={icon_spot.background_color ? {backgroundColor: icon_spot.background_color} : {}}
    >
      <Image height={24} src={tagToUrl(icon_spot.icon.image_tag)} />
    </div>
  )
})
